(function () {
  if (window.KronkDropCountdownLoaded) return;
  window.KronkDropCountdownLoaded = true;

  const timers = new Set();

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function setValue(timer, unit, value) {
    const element = timer.querySelector(`[data-kronk-drop-unit="${unit}"]`);
    if (element) element.textContent = value;
  }

  function updateTimer(timer) {
    const target = Date.parse(timer.dataset.kronkDropLaunchAt || '');
    if (!Number.isFinite(target)) return;

    const remaining = Math.max(0, target - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    setValue(timer, 'days', String(days));
    setValue(timer, 'hours', pad(hours));
    setValue(timer, 'minutes', pad(minutes));
    setValue(timer, 'seconds', pad(seconds));

    timer.toggleAttribute('data-kronk-drop-complete', remaining === 0);

    if (remaining === 0) {
      refreshLockedDropPage(timer);
    }
  }

  function refreshLockedDropPage(timer) {
    const hasLockedDropContent = document.querySelector(
      '[data-kronk-drop-locked="true"], .product--drop-locked, .product-info--drop-locked, .kronk-card-drop-note, .kronk-card-variants__link--drop'
    );

    if (!hasLockedDropContent) return;

    const launchAt = timer.dataset.kronkDropLaunchAt || 'launch';
    const refreshKey = `kronk-drop-refreshed:${window.location.pathname}:${launchAt}`;

    try {
      if (window.sessionStorage.getItem(refreshKey)) return;
      window.sessionStorage.setItem(refreshKey, 'true');
    } catch (error) {
      if (timer.hasAttribute('data-kronk-drop-refreshing')) return;
      timer.setAttribute('data-kronk-drop-refreshing', 'true');
    }

    window.setTimeout(() => {
      window.location.reload();
    }, 700);
  }

  function collectTimers(root) {
    root.querySelectorAll('[data-kronk-drop-countdown]').forEach((timer) => {
      timers.add(timer);
      updateTimer(timer);
    });
  }

  function tick() {
    timers.forEach(updateTimer);
  }

  document.addEventListener('DOMContentLoaded', () => collectTimers(document));
  document.addEventListener('shopify:section:load', (event) => collectTimers(event.target));

  if (document.readyState !== 'loading') collectTimers(document);
  window.setInterval(tick, 1000);
})();
